export class EditionNames {
    static Standard = "HealthEdition.Standard";
    static Gold = "HealthEdition.Gold";
    static Optimum = "HealthEdition.Optimum";
    static Platinum = "HealthEdition.Platinum";
    static Lite = "Health.Edition.Lite";
    static Essential = "HealthEdition.Essential";
    static Pro = "HealthEdition.Pro";
    static Premium = "HealthEdition.Premium";
    static MedqEssential = "HealthEdition.Medq.Essential";
    static HealthEngagePro = "HealthEdition.EngagePro";
    static HealthEngagePremium = "HealthEdition.EngagePremium";
    static HealthEngageStarter = "HealthEdition.EngageStarter";
    static HealthEngageDoctorWebApp = "HealthEdition.EngageDoctorWebApp";
    static HealthEngageGrowWebApp = "HealthEdition.EngageGrowWebApp";
    static HealthEngageClinicWebApp = "HealthEdition.EngageClinicWebApp";
    
    public static EngageEditions() {
        return [this.HealthEngagePro, this.HealthEngagePremium, this.HealthEngageStarter]
    }
}